// extracted by mini-css-extract-plugin
export default {"container":"MawashiKup_container__dZWqr","naslov":"MawashiKup_naslov__lZEs7","content":"MawashiKup_content__+MR60","gallery":"MawashiKup_gallery__wiQvE"};